import { render, staticRenderFns } from "./NuevoUsuario.vue?vue&type=template&id=7f21f710&scoped=true"
import script from "./NuevoUsuario.vue?vue&type=script&lang=ts"
export * from "./NuevoUsuario.vue?vue&type=script&lang=ts"
import style0 from "./NuevoUsuario.vue?vue&type=style&index=0&id=7f21f710&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f21f710",
  null
  
)

export default component.exports